let baseUrl;
let env;
if (process.env.NODE_ENV == 'development') {
    env = require('./dev.env')
} else if (process.env.NODE_ENV == 'test') {
    env = require('./dev.env')
} else if (process.env.NODE_ENV == 'production') {
    env = require('./prod.env')
} else {
    env = {"API" : "nothing"}
}
baseUrl = env.API;

export default baseUrl